export default __webpack_public_path__ + "static/Baccarat-ea2daa2bfa946e139893ed550c9f64c1.svg";